import { AxiosError } from 'axios'
import i18n from '@/lib/i18n'

export const isForbiddenApiError = (error: unknown): boolean => {
	return error instanceof AxiosError && error.response?.status === 403
}

// Lancado no cliente quando, mesmo apos a compressao, o payload excederia o limite
// do proxy de producao (~1MB) — evita uma ida a rede fadada a falhar com 413.
export class PayloadTooLargeError extends Error {
	constructor(totalBytes: number) {
		super(`Upload payload too large: ${totalBytes} bytes`)
		this.name = 'PayloadTooLargeError'
	}
}

// Proxies/gateways (nginx/openresty) rejeitam corpos acima do limite configurado
// com 413 antes de a requisicao chegar na API.
export const isPayloadTooLargeApiError = (error: unknown): boolean => {
	return (
		error instanceof PayloadTooLargeError ||
		(error instanceof AxiosError && error.response?.status === 413)
	)
}

export const getApiErrorMessage = (error: unknown): string => {
	if (error instanceof AxiosError) {
		if (!error.response) {
			return i18n.t('errors.network')
		}
		return error.response.data?.data ?? i18n.t('errors.generic')
	}
	return i18n.t('errors.generic')
}
